import React from 'react';
import './Home.css';
import Social from './Social';
import Data from './Data';
import ScrollDown from './ScrollDown';
import portfolioData from '../../portfolio.json';

export default function Home() {
  const { home } = portfolioData;
  return (
    <section className='home section' id='home'>
      <div className='home__container container grid'>
        <div className='home__content grid'>
          <Social social={home.social} />
          <div className='home__img' style={{ backgroundImage: `url(${process.env.PUBLIC_URL + home.image})` }}></div>
          <Data home={home} />
        </div>
        <ScrollDown />
      </div>
    </section>
  )
}
